import React, { FC, Ref } from 'react';
import MuiMenuItem, { MenuItemProps as MuiMenuItemProps } from '@material-ui/core/MenuItem';
import { Uds } from '../../types';

type FCProps<Component extends keyof JSX.IntrinsicElements | FC = 'li'> =
  Component extends FC<infer Props> ? Props : {};

// See https://github.com/mui/material-ui/issues/16245 for why extra 'li' typing is required.
export type MenuItemProps<COMPONENT extends keyof JSX.IntrinsicElements | FC> = Uds<
  MuiMenuItemProps<COMPONENT, { button?: true; component?: COMPONENT } & FCProps<COMPONENT>> & {
    children?: React.ReactNode;
  }
>;

export const MenuItem = React.forwardRef(
  <T extends keyof JSX.IntrinsicElements | FC = 'li'>(
    { dataTest, ...props }: MenuItemProps<T>,
    ref: Ref<HTMLLIElement>
  ) => <MuiMenuItem data-test={dataTest} ref={ref} {...props} />
);
